import {createSelector, MemoizedSelector} from '@ngrx/store';
import {selectAllFence} from '@app/store/faxe/fences/fence.reducer';
import {getFenceState} from '@app/store/faxe/faxe-selectors';
import { FenceRace } from '@app/store/faxe/fences/model/fence-race';



export const selectFenceAll: MemoizedSelector<object, FenceRace[]> = createSelector(
  getFenceState,
  selectAllFence
);

export const selectFenceByRaceGuid = (raceRaceGuid: string):
  MemoizedSelector<object, FenceRace[]> =>
  createSelector(
    getFenceState,
    selectFenceAll,
    (state, all) => all
      .filter(fenceRace => fenceRace.raceGuid === raceRaceGuid)
  );

export const selectFenceById = (fenceGuid: string):
  MemoizedSelector<object, FenceRace> =>
  createSelector(
    getFenceState,
    selectFenceAll,
    (state, all) => all
        .find(x => x.fenceGuid === fenceGuid)
  );
